import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable, tap, map, catchError, throwError, of, BehaviorSubject, switchMap, take, filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthStatus, CheckTokenResponse, LoginResponse, User } from '../interfaces';
import { RegisterUserInterface } from 'src/app/sadi/interfaces/register-user.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';
import { Router } from '@angular/router';
import { UsersService, TypeDocIDService, RequestStatusService } from 'src/app/sadi/services';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly baseUrl: string = environment.baseUrlAuth;
  private http = inject( HttpClient );
  private coreService = inject( CoreService );
  private router = inject( Router );
  private redirecting = false;
  private usersService          = inject( UsersService );
  private typeDocIDService      = inject( TypeDocIDService );
  private requestStatusService  = inject(RequestStatusService);

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private _currentUser = signal<CheckTokenResponse| null |User>(null);
  private _authStatus = signal<AuthStatus>( AuthStatus.checking );

  //! Fuera del servicio


  public currentUser = computed( () => this._currentUser() );
  public authStatus  = computed( () => this._authStatus() );


  constructor() {
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      this._currentUser.set(JSON.parse(storedUser));
      this._authStatus.set(AuthStatus.authenticated);
    }
    // this.init();

    // this.checkAuthStatus().subscribe({
    //   error: () => {
    //     this._authStatus.set(AuthStatus.notAuthenticated);
    //   },
    //   complete: () => {
    //     const urlSaved = localStorage.getItem('url');
    //     const url = window.location.pathname;
    //     if (url !== '/auth/login' && url !== '/') {
    //       localStorage.setItem('url', url);
    //     }
    //     switch (this.authStatus()) {
    //       case AuthStatus.checking:
    //         console.log('Checking')
    //         break;
    //       case AuthStatus.authenticated:
    //         // this.router.navigateByUrl('sadi');
    //         this._authStatus.set(AuthStatus.authenticated);
    //         this.router.navigateByUrl(urlSaved?.toString() || 'sadi');
    //         break;
    //       case AuthStatus.notAuthenticated:
    //         console.log('Not authenticated');
    //         // Verificar si la verificación de autenticación ya ha finalizado
    //         if (this.authStatus() !== AuthStatus.checking) {
    //           // Solo redirigimos si no estamos ya en proceso de redirección
    //           if (!this.redirecting) {
    //             this.redirecting = true;
    //             // Esperar un breve período de tiempo antes de ejecutar el logout
    //             setTimeout(() => {
    //               this.logout();
    //               // Redirigir al usuario a la página de inicio de sesión
    //               this.router.navigateByUrl('/auth/login');
    //             }, 1000); // Esperar 1 segundo (1000 milisegundos)
    //           }
    //         }
    //         // this.router.navigateByUrl('/auth');
    //         this.router.navigateByUrl('/auth/login');
    //         break;
    //       default:
    //         console.log('Default')
    //         break;
    //     }
    //   }
    // });
  }

  private init(): void {
    this.checkAuthStatus().pipe(take(1)).subscribe({
      error: () => {
        this._authStatus.set(AuthStatus.notAuthenticated);
      },
      complete: () => {
        this.handleAuthComplete();
      }
    })
  }

  private handleAuthComplete(): void {
    const urlSaved = localStorage.getItem('url');
    const url = window.location.pathname;

    if (url !== '/auth/login' && url !== '/') {
      localStorage.setItem('url', url);
    }

    switch (this.authStatus()) {
      case AuthStatus.checking:
        console.log('Checking');
        break;
      case AuthStatus.authenticated:
        this._authStatus.set(AuthStatus.authenticated);
        this.router.navigateByUrl(urlSaved?.toString() || 'sadi');
        break;
      case AuthStatus.notAuthenticated:
        console.log('Not authenticated');
        if (this.authStatus() !== AuthStatus.checking) {
          if (!this.redirecting) {
            this.redirecting = true;
            setTimeout(() => {
              this.logout();
              this.router.navigateByUrl('/auth/login');
            }, 1000);
          }
        }
        this.router.navigateByUrl('/auth/login');
        break;
      default:
        console.log('Default');
        break;
    }


  }

  private setAuthentication(response: User | CheckTokenResponse): boolean {
    // Validar si es la primera vez que se esta logueando el usuario //!hasOwnProperty
    this._currentUser.set(response);
    this._authStatus.set( AuthStatus.authenticated );
    const storageItems = {
      token: response.token,
      refreshToken: response.refreshToken,
      userRoles: response.rolesUser ? JSON.stringify(response.rolesUser) : null
    };

    Object.entries(storageItems).forEach(([key, value]) => {
      if (value) localStorage.setItem(key, value);
    });
    localStorage.setItem('currentUser', JSON.stringify(response));
    // localStorage.setItem('userRoles', JSON.stringify(response.rolesUser));
    return true;
  }


  login( email: string, password: string ): Observable<boolean> {

    const url   = `${this.baseUrl}/api/auth/login`;
    const body  = { email: email, password:password };

    return this.http.post<LoginResponse>( url, body )
      .pipe(
        map((response) => {
          this._currentUser.set(response);
          // // Incrementar el contador de inicio de sesión
          // let loginCount = parseInt(localStorage.getItem(`${this.currentUser()?.id}loginCountV0`) || '0');
          // loginCount++;
          // localStorage.setItem(`${this.currentUser()?.id}loginCountV0`, loginCount.toString());
          // localStorage.setItem( 'token', response.token );


          // // Mostrar el modal o diálogo las tres primeras veces
          // if (loginCount < 4) {
          //   this.showModal();
          // }

          // Establecer la autenticación y redirigir
          this.setAuthentication(response);

          // this.usersService.updateRequestUserActive();
          // this.typeDocIDService.updateFecthTypeID();
          // this.requestStatusService.updateRequestStatus();

          return true;
        }),

        catchError( err => {
          return throwError(() => err.error.message)
        })
      );
  }

  // checkAuthStatus(): Observable<boolean> {
  //   const url   = `${this.baseUrl}/api/auth/check-status`;
  //   const token = localStorage.getItem('token');

  //   if ( !token ) {
  //     this.logout();
  //     return of(false);
  //   }

  //   const headers = new HttpHeaders()
  //     .set(`Authorization`, `Bearer ${token}`);

  //     return this.http.get<CheckTokenResponse>(url, {headers})
  //       .pipe(
  //         map( (response) => this.setAuthentication(response)),

  //         catchError(() => {
  //           this._authStatus.set(AuthStatus.notAuthenticated)
  //           return of(false)
  //         })
  //       )

  // }

  checkAuthStatus(): Observable<boolean> {
    // console.log('[PROD] Iniciando checkAuthStatus');

    // if (this.isChecking) {
    //   console.log('[PROD] CheckAuth ya en progreso, retornando estado actual');
    //   return this.checkingStatus$.asObservable();
    // }

    const url = `${this.baseUrl}/api/auth/check-status`;
    const token = localStorage.getItem('token');

    if (!token) {
      // console.log('[PROD] No token encontrado');
      this.logout();
      return of(false);
    }

    const headers = new HttpHeaders().set(`Authorization`, `Bearer ${token}`);

    // Establecer el estado de autenticación como "checking" mientras se verifica
    this._authStatus.set(AuthStatus.checking);

    return this.http.get<CheckTokenResponse>(url, { headers }).pipe(
      map((response) => this.setAuthentication(response)),
      catchError((err) => {
        if (err.error.statusCode === 401) {
          // console.log('[PROD] Error en checkAuth:', err);
          // return this.refreshToken();
          return of(false);
        } else {
          this._authStatus.set(AuthStatus.notAuthenticated);
          return of(false);
        }
      })
    )
  }

  refreshToken(): Observable<boolean> {
    const url = `${this.baseUrl}/api/auth/refreshToken`;
    const refreshToken = localStorage.getItem('refreshToken');
    const body = { refreshToken };

    return this.http.post<LoginResponse>(url, body)
      .pipe(
        map((response) => {
          // No sobrescribimos todo el usuario; solo actualizamos tokens
          if (response.token) {
            localStorage.setItem('token', response.token);
          }
          if (response.refreshToken) {
            localStorage.setItem('refreshToken', response.refreshToken);
          }
          // Mantenemos el resto de datos de currentUser
          this._authStatus.set(AuthStatus.authenticated);
          return true;
        }),
        catchError((error) => {
          this._authStatus.set(AuthStatus.notAuthenticated);
          if (error.error.statusCode === 401) {
            this.logout();
            return of(false);
          }
          return of(false);
        })
      );
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userRoles');
    this._currentUser.set(null);
    this._authStatus.set( AuthStatus.notAuthenticated );
    this.router.navigateByUrl('/auth/login');
  }

  registerUser(body: RegisterUserInterface): Observable<RegisterUserInterface[]> {
    // Obtiene el token de autorización de donde corresponda
    const authToken = localStorage.getItem('token');

    // Configura los encabezados con el token de autorización
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.post<RegisterUserInterface[]>(`${this.baseUrl}/api/auth/register`, body, { headers });
  }

  // showModal() {
  //   this.coreService.dialogAnuncios('Gracias por usar nuestra aplicación', 'Ok')
  //   // this.coreService.showInfo('Gracias por usar nuestra aplicación')
  // }



}
